<template>
    <div>
        <div class="celular">
            <div class="tela">
                <div class="header">
                    <span class="avatar" />
                    <span class="saudacao">
                        <small>Olá,</small>
                        <strong>Maria</strong>
                    </span>
                </div>

                <div class="conteudo">
                    <div
                        class="banner"
                        :style="{ background: gradiente }"
                    >
                        <span class="banner-icone">
                            <BannerIcone :icone="model.icone" />
                        </span>
                        <span class="banner-textos">
                            <strong>{{ model.titulo || 'Título do banner' }}</strong>
                            <span>{{ model.texto || 'Texto do banner' }}</span>
                        </span>
                    </div>

                    <div class="dots">
                        <span
                            class="ativo"
                            :style="{ background: model.cor }"
                        />
                        <span />
                        <span />
                        <span />
                    </div>

                    <strong class="secao">Serviços Rápidos</strong>
                    <div class="servicos">
                        <span
                            v-for="servico in servicos"
                            :key="servico"
                        >
                            {{ servico }}
                        </span>
                    </div>
                </div>

                <div class="tabbar">
                    <span>Família</span>
                    <span class="ativo">Início</span>
                    <span>Perfil</span>
                </div>
            </div>
        </div>

        <p class="legenda">É assim que o banner aparece no carrossel da tela inicial.</p>
    </div>
</template>

<script>
import BannerIcone from './BannerIcone'

const escurecer = hex => {

    const n = parseInt(hex.slice(1), 16)
    const canal = valor => Math.round(valor * 0.7).toString(16).padStart(2, '0')

    return `#${canal((n >> 16) & 255)}${canal((n >> 8) & 255)}${canal(n & 255)}`
}

export default {
    components: { BannerIcone },
    computed: {
        gradiente() {

            const cor = this.model.cor || '#0A6CDB'

            return `linear-gradient(135deg, ${escurecer(cor)}, ${cor})`
        },
    },
    data: () => ({
        servicos: ['Agendamentos', 'Histórico', 'Minhas Receitas', 'Vacinação', 'Cartão SUS', 'Encaminhamentos'],
    }),
    props: {
        model: { type: Object, required: true },
    },
}
</script>

<style scoped>
    .celular {
        width: 300px;
        margin: 0 auto;
        padding: 10px;
        border-radius: 40px;
        background: #111827;
    }
    .tela {
        position: relative;
        height: 600px;
        overflow: hidden;
        border-radius: 30px;
        background: #F9FAFB;
        font-family: Montserrat, sans-serif;
    }
    .header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 38px 14px 22px;
        border-radius: 0 0 12px 12px;
        background: #282850;
        color: #FFFFFF;
    }
    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #FFFFFF;
    }
    .saudacao {
        display: flex;
        flex-direction: column;
        line-height: 1.2;
    }
    .conteudo {
        padding: 12px;
    }
    .banner {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px;
        border-radius: 12px;
        color: #FFFFFF;
    }
    .banner-icone {
        display: flex;
        flex: 0 0 42px;
        align-items: center;
        justify-content: center;
        height: 42px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
    }
    .banner-textos {
        display: flex;
        flex-direction: column;
        gap: 3px;
        min-width: 0;
        overflow-wrap: anywhere;
    }
    .banner-textos strong {
        font-size: 13px;
        line-height: 1.2;
    }
    .banner-textos span {
        font-size: 11px;
        line-height: 1.45;
        color: rgba(255, 255, 255, 0.88);
    }
    .dots {
        display: flex;
        justify-content: center;
        gap: 5px;
        margin: 8px 0 16px;
    }
    .dots span {
        width: 6px;
        height: 6px;
        border-radius: 3px;
        background: #D1D5DB;
    }
    .dots span.ativo {
        width: 16px;
    }
    .secao {
        display: block;
        margin-bottom: 10px;
        font-size: 14px;
    }
    .servicos {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
    .servicos span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 64px;
        border-radius: 10px;
        background: #FFFFFF;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
        font-size: 10px;
        color: #4B5563;
    }
    .tabbar {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 56px;
        background: #282850;
        font-size: 10px;
        color: #D1D5DB;
    }
    .tabbar .ativo {
        font-weight: 700;
        color: #FFFFFF;
    }
    .legenda {
        margin: 12px 0 0;
        font-size: 13px;
        text-align: center;
        color: #6C757D;
    }
</style>
